const packageFile = require('../package.json');
module.exports = packageFile.version;
